import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";

const Promotion = props => {
	const classes = useStyles();
	const { product, isConditionPromotion } = props;

	return product?.stock === 0 ? (
		<React.Fragment>
			<Grid
				classes={{ root: classes.rootBoxdow }}
				style={{ background: "#808080" }}
			/>
			<Grid
				classes={{ root: classes.rootPromotion }}
				style={{
					background: `linear-gradient(271.71deg, #7D7D7D 1.65%, #939090 99.59%)`
				}}
			>
				Hết hàng
			</Grid>
		</React.Fragment>
	) : (product?.stock !== 0 && product?.isPromotion) ||
	  isConditionPromotion ? (
		<React.Fragment>
			<Grid
				classes={{ root: classes.rootBoxdow }}
				style={{ background: "#148F39" }}
			/>
			<Grid
				classes={{ root: classes.rootPromotion }}
				style={{
					background: `linear-gradient(96.52deg, #0FB752 1.22%, #B3DA46 132.79%, #E4E825 213.84%, #E83025 242.78%)`
				}}
			>
				Khuyến mãi
			</Grid>
		</React.Fragment>
	) : null;
};

export default memo(Promotion);
